import { render } from "./HonorarkostenOhneQuali.pug?vue&type=template&id=4f5eacc3&lang=pug"
import script from "./HonorarkostenOhneQuali.js?vue&type=script&lang=js"
export * from "./HonorarkostenOhneQuali.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__